var map = {
	"./accessibility.png": 3875,
	"./accessibility_2.png": 9992,
	"./arrow.png": 4931,
	"./avatar_test.png": 310,
	"./avatart_test.png": 5890,
	"./bestpractices.png": 9029,
	"./bestpractices_2.png": 2418,
	"./chakraui.png": 7829,
	"./css.png": 7914,
	"./cta.png": 1947,
	"./english.png": 7194,
	"./figma.png": 1566,
	"./framermotion.png": 8550,
	"./german.png": 4751,
	"./git.png": 8175,
	"./github.png": 4343,
	"./html.png": 867,
	"./icon.png": 286,
	"./javascript.png": 6500,
	"./next.png": 3831,
	"./next_2.png": 6994,
	"./photoshop.png": 4549,
	"./python.png": 3660,
	"./react.png": 357,
	"./redux.png": 3212,
	"./sass.png": 8339,
	"./screen5.png": 9400,
	"./seo.png": 6818,
	"./seo_2.png": 909,
	"./tailwind.png": 5847,
	"./typescript.png": 8680,
	"./vscode.png": 445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;